<div class="block-header">
    <h3 class="block-header__title">{{ name }}</h3>

    <ul *ngIf="blockProductCarouselService.carouselHeadersValue?.length" class="block-header__groups-list">
        <li *ngFor="let header of blockProductCarouselService.carouselHeadersValue">
            <button type="button" class="block-header__group" [ngClass]="{'block-header__group--active': header.id == blockProductCarouselService.selectedHeaderValue?.id}" (click)="setHeader(header)">{{ header.name?.en }}</button>
        </li>
    </ul>

    <div *ngIf="arrows" class="block-header__arrows-list ml-auto">
        <button class="block-header__arrow block-header__arrow--left" type="button" (click)="prev.emit()">
            <app-icon name="arrow-rounded-left-7x11" size="7x11"></app-icon>
        </button>
        <button class="block-header__arrow block-header__arrow--right" type="button" (click)="next.emit()">
            <app-icon name="arrow-rounded-right-7x11" size="7x11"></app-icon>
        </button>
    </div>
</div>
